export default "__VITE_ASSET__fv4FyoIj__"